import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AppService } from '../../../app.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Intervention } from '../../../models/intervention';
import { Rucher } from '../../../models/rucher';
import { DateJson } from '../../../outils/dateJson';

@Component({
  selector: 'app-detail-intervention',
  templateUrl: './detail-intervention.component.html',
  styleUrls: ['./detail-intervention.component.css']
})
export class DetailInterventionComponent implements OnInit {
  private id: string;
  private intervention: Intervention = new Intervention();
  private rucher: Rucher;

  constructor(private appService: AppService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    if (this.appService.nomenclatures.length === 0) {
      this.router.navigate(['']);
    } else {
      this.id = this.route.snapshot.paramMap.get('id');
      this.appService.getIntervention(this.id).subscribe(intervention => {
        intervention.date_inter = new DateJson(new Date(intervention.date_inter.annee, intervention.date_inter.mois, intervention.date_inter.jour));
        this.intervention=intervention;
        this.rucher = this.appService.getRucher(intervention.id_rucher);
      });
    }
  }
  
  afficheInterventionsRucher(id_rucher: string) {
    this.router.navigate(['listeinter', id_rucher], { skipLocationChange: true, relativeTo: this.route.parent });
  }

}



// WEBPACK FOOTER //
// ./src/app/principal/interventions/detail-intervention/detail-intervention.component.ts